import { meta } from '../../../../constants';
import type { DemoSourceType } from '../types';
import type { TumblrSourceValue } from './types';

const extraTumblrSources: DemoSourceType<TumblrSourceValue> = {
  'tumblr-condenasttraveler': {
    label: 'Tumblr: @condenasttraveler',
    source: {
      platform: 'tumblr',
      connectionType: 'tumblrData',
      id: 'kkpc84kc',
      name: 'Tumblr',
      source: 'condenasttraveler'
    }
  },
  'tumblr-designclever': {
    label: 'Tumblr: @designclever',
    source: {
      platform: 'tumblr',
      connectionType: 'tumblrData',
      id: 'kkpc8d02',
      name: 'Tumblr',
      source: 'designclever'
    }
  },
  'tumblr-elle': {
    label: 'Tumblr: @elle',
    source: {
      platform: 'tumblr',
      connectionType: 'tumblrData',
      id: 'kkpc8jbl',
      name: 'Tumblr',
      source: 'elle'
    }
  },
  'tumblr-icanread': {
    label: 'Tumblr: @icanread',
    source: {
      platform: 'tumblr',
      connectionType: 'tumblrData',
      id: 'kkpc8pl8',
      name: 'Tumblr',
      source: 'icanread'
    }
  },
  'tumblr-monk3y': {
    label: 'Tumblr: @monk3y',
    source: {
      platform: 'tumblr',
      connectionType: 'tumblrData',
      id: 'kkpc8wcn',
      name: 'Tumblr',
      source: 'monk3y'
    }
  },
  'tumblr-weandthecolor': {
    label: 'Tumblr: @weandthecolor',
    source: {
      platform: 'tumblr',
      connectionType: 'tumblrData',
      id: 'kkpc9a81',
      name: 'Tumblr',
      source: 'weandthecolor'
    }
  }
};

export const previewTumblrSources: DemoSourceType<TumblrSourceValue> = {
  'tumblr-culture-and-literature': {
    label: 'Tumblr: @culture-and-literature',
    source: {
      platform: 'tumblr',
      connectionType: 'tumblrData',
      id: 'kk2ok9ll',
      name: 'Tumblr',
      source: 'https://www.tumblr.com/blog/view/culture-and-literature'
    }
  },
  'tumblr-designcloud': {
    label: 'Tumblr: @designcloud',
    source: {
      platform: 'tumblr',
      connectionType: 'tumblrData',
      id: 'kkpc7sg2',
      name: 'Tumblr',
      source: 'designcloud'
    }
  },
  'tumblr-laphamsquarterly': {
    label: 'Tumblr: @laphamsquarterly',
    source: {
      platform: 'tumblr',
      connectionType: 'tumblrData',
      id: 'kkpc7wdn',
      name: 'Tumblr',
      source: 'laphamsquarterly'
    }
  },
  ...(meta.alias === 'tumblr-feed' ? extraTumblrSources : {})
};
